import { render, staticRenderFns } from "./pkgChange.vue?vue&type=template&id=4f6344c6&scoped=true&"
import script from "./pkgChange.vue?vue&type=script&lang=js&"
export * from "./pkgChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6344c6",
  null
  
)

export default component.exports